import { render, staticRenderFns } from "./MetaData.vue?vue&type=template&id=07d053e7"
import script from "./MetaData.vue?vue&type=script&lang=js"
export * from "./MetaData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports